var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.surgeryId)?_c('p',[_c('br'),_c('br'),_c('br'),_vm._v(" Please select a location pin on map ")]):_c('p',[_vm._v(" Settings here @@TODO ")])])}
var staticRenderFns = []

export { render, staticRenderFns }